<template>
  <div class="sub-navbar">
    <p class="align-left">
      Vendita Kayaks dal 1979
    </p>
    <p class="align-right">
      <a
        href="https://www.facebook.com/ArtFiber.kayak.canoe"
        target="_blank">
          <img
            src="@/assets/images/common/facebook_1024.png"
            class="social-logo"
          />
      </a>
      <a href="https://www.instagram.com/artFiber"
          target="_blank">
          <img
            src="@/assets/images/common/instagram_1024.png"
            class="social-logo"
          />
      </a>
    </p>
    <div style="clear: both;"></div>
  </div>
</template>

<script>
export default {
  name: 'sub-nav-bar'
}
</script>
